<script lang="ts">
  /**
   * Centralized reusable Button
   */
  /** @type {string} custom styles */
  export let style: string = "margin: auto; float: none"
  /** @type {function} click function */
  export let clickHandler: () => void
  /** @type {string} any extra classes to append to the button */
  export let extraClasses: string = ""
  /** custom configured tracking function */
  export let trackButtonClick: (item?: string) => void = () => undefined
</script>

<div
  class={`auws-button ${extraClasses}`}
  tabindex="0"
  role="button"
  {style}
  on:click={() => {
    trackButtonClick()
    clickHandler()
  }}
  on:keydown={(event) => {
    if (event.key === " " || event.key === "Enter") {
      trackButtonClick()
      clickHandler()
    }
  }}
  on:keypress={() => undefined}
>
  <slot />
</div>

<style>
  .auws-button {
    display: inline-block;
    font-weight: normal;
    text-align: center;
    white-space: nowrap;
    vertical-align: middle;
    touch-action: manipulation;
    cursor: pointer;
    border: 1px solid transparent;
    padding: 8px 10px 8px 10px;
    background-color: transparent;
    font-size: 14px;
    font-weight: 400;
    font-style: normal;
    text-decoration: none;
    box-sizing: border-box;
  }
</style>
